<template>
  <div class="text-xs-center">
    <v-menu
      v-model="menu"
      :nudge-width="100"
      bottom
      origin="center center"
      transition="scale-x-transition"
    >
      <template v-slot:activator="{ on }">
        <v-btn color="white" dark v-on="on" flat>
          <avatar color="#fff" backgroundColor="#F4511E" :size="40" :username="user.email"></avatar>
        </v-btn>
      </template>

      <v-card>
        <v-list>
          <v-list-tile >
            <v-list-tile-content>
              <v-list-tile-title v-if="user.name">{{user.name}}</v-list-tile-title>
              <v-list-tile-sub-title>
                <span>{{ user.email }}</span>
                  <span>&nbsp;•&nbsp;</span>
                  <span><b>{{ DEFINES.ROLE_STR[company.pivot.role] }}</b></span>
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>

        <v-divider></v-divider>

        <v-list>
          <v-list-tile :to="{name: 'UserProfile'}">
            <v-list-tile-action>
              <v-icon>$vuetify.icons.rms_user_profile</v-icon>
            </v-list-tile-action>
            <v-list-tile-title >{{$t('screener.admin.drawer.menu.profile')}}</v-list-tile-title>
          </v-list-tile>
          <Logout v-if="is_logout"></Logout>
          <v-divider v-if="user.role == DEFINES.USER_ROLE_SUPER_ADMIN"></v-divider>
          <admin-switcher v-if="user.role == DEFINES.USER_ROLE_SUPER_ADMIN"></admin-switcher>
        </v-list>
      </v-card>
    </v-menu>
  </div>
</template>
<script>
import Avatar from "vue-avatar";
import { mapFields } from "vuex-map-fields";
import { mapGetters, mapState } from "vuex";
import Logout from "@/components/Logout";
import AdminSwitcher from "@/components/AdminSwitcher";
export default {
  props: {
    is_logout: {
      default: true,
    },
  },
  data: () => ({
    fav: true,
    menu: false,
    message: false,
    hints: true,
  }),
  components: {
    Avatar,
    Logout,
    AdminSwitcher
  },
  computed: {
    ...mapState({
      user: (state) => state.user.profile,
    }),
    ...mapGetters({
      company: "company/getSelectedCompany",
      timezone: "getSelectedCompanyTimezone",
    }),
  }
};
</script>
